import { NumberFormat, toLocaleString as _toLocaleString, } from '.';
import { defineProperty } from '@formatjs/intl-utils';
defineProperty(Intl, 'NumberFormat', { value: NumberFormat });
defineProperty(Number.prototype, 'toLocaleString', {
    value: function toLocaleString(locales, options) {
        return _toLocaleString(this, locales, options);
    },
});
//# sourceMappingURL=polyfill-force.js.map